export default {
    cells: "/",
    board: "/board/:board_id",
    user_board: "/board/:board_id/user/:username",
    login: "/login",
    register: "/register",
    verify_email: "/verify-email/:key",
}
